import { getStorage, ref, getDownloadURL } from 'firebase/storage';

/**
 * Download PDF from Firebase Storage using the storage path
 * @param {string} pdfPath - Storage path to the PDF file
 * @returns {Promise<string>} Download URL for the PDF
 */
export async function downloadPdfFromStorage(pdfPath) {
  try {
    const storage = getStorage();
    const pdfRef = ref(storage, pdfPath);
    const downloadURL = await getDownloadURL(pdfRef);
    return downloadURL;
  } catch (error) {
    console.error('Error downloading PDF from Storage:', error);
    throw new Error('Failed to download PDF from storage');
  }
}

/**
 * Generate a signed URL for a PDF in Storage (alternative to getDownloadURL)
 * @param {string} pdfPath - Storage path to the PDF file
 * @returns {Promise<string>} Signed URL for the PDF
 */
export async function generateSignedUrlForPdf(pdfPath) {
  // For now, we'll use getDownloadURL as it's simpler and works for most cases
  // In production, you might want to use a Cloud Function to generate signed URLs
  // for better security and control over expiration
  return downloadPdfFromStorage(pdfPath);
}
